import { useEffect, useRef, useState } from "react";
import {
  RequestPagamentoCartao,
  ResponsePagamentoCartao,
} from "../../../../services/contrato/MapperPagamentoCartao";
import { toast } from "react-toastify";
import {
  BotaoCadastrarCartaoModal,
  BotaoCancelar,
  BotoesModal,
  BottomSheetCustomizada,
  CabecalhoModal,
  CartaoModal,
  ContainerBodyModal,
  ContainerBottomSheet,
  ContainerCabecalhoBottomSheet,
  ContainerCartaoModal,
  ContainerInputsModal,
  ContainerPopup,
  InputsVencimentoCvv,
  LinhaCabecalho,
  NomeCartaoModal,
  NumeroCartaoModal,
  PopupCustomizado,
  StyledTextField,
  SubTextoCabecalhoModalNovoCartao,
  TextoBotaoCadastrarCartaoModal,
  TextoBotaoCancelar,
  TextoCabecalhoBottomSheet,
  TextoCabecalhoModalNovoCartao,
  InputsDatasCartao,
} from "./styles";
import { CampoDeTexto } from "../../../../components/CampoInput";
import { formatarCPF } from "../../../../utils/formatarCpf";
import useTamanhoTela from "../../../../utils/useTamanhoTela";
import { useApi } from "../../../../contexts/api";
import Carregando from "../../../carregando";
import dayjs from "dayjs";
import { validarCPF } from "../../../../utils/validarCPF";
import { TextoAlterarCartao } from "../../detalhesPlano/fatura/styles";
import { TextoInformacoesPlano } from "../../../empresas/pagina3Contrato/pagina1/styles";
import { useAuth } from "../../../../contexts/auth";
import { useTranslation } from "react-i18next";
import {formatarDataEHorarioParaPadraoBrasileiro} from "../../../../utils/formatarDataPadraoBrasileiro";

export default function ModalCadastrarCartao({
  componenteTrigger,
  onCadastradoComSucesso,
  dadosEditar,
}) {
  const { t } = useTranslation("common");
  const { t: tPagamento } = useTranslation("pagamento");
  const { post, get, put } = useApi();
  const { largura } = useTamanhoTela();
  const { dadosAuth } = useAuth();
  const { empresaDTO } = dadosAuth;
  console.log(empresaDTO, dadosAuth);
  const [nomeCartao, setNomeCartao] = useState("");
  const [numeroCartao, setNumeroCartao] = useState("");
  const [validade, setValidade] = useState("");
  const [codigoSeguranca, setCodigoSeguranca] = useState("");
  const [cpf, setCpf] = useState("");
  const [openCartao, setOpenCartao] = useState(false);
  const [dataAlteracao, setDataAlteracao] = useState(null);
  const [dataCriacao, setDataCriacao] = useState(null);


  const [erros, setErros] = useState({});

  const [loading, setLoading] = useState(dadosEditar ? true : false);

  function handleChangeNomeCartao(e) {
    let nome = e.target.value.replace(/\d/g, "").toUpperCase();

    if (!String(nome).length) {
      setErros((prev) => ({
        ...prev,
        nomeDonoCartao: tPagamento("cards.fillName"),
      }));
    } else {
      setErros((prev) => {
        const { nomeDonoCartao, ...rest } = prev;
        return rest;
      });
    }

    setNomeCartao(nome);
  }

  function verificarDataValidade(novoValor) {
    let data = dayjs();
    // Parse MMYYYY and compare with current month/year
    if (novoValor.length >= 6) {
      const mes = parseInt(novoValor.slice(0, 2), 10);
      const ano = parseInt(novoValor.slice(2, 6), 10);

      if (!isNaN(mes) && !isNaN(ano) && mes >= 1 && mes <= 12) {
        const dataInformada = data
          .set("month", mes - 1)
          .set("year", ano)
          .endOf("month");
        const atual = dayjs().endOf("month");

        if (
          dataInformada.isBefore(atual, "month") ||
          dataInformada.isSame(atual, "month")
        ) {
          setErros((prev) => ({
            ...prev,
            validade: tPagamento("cards.expired"),
          }));
        } else {
          setErros((prev) => {
            const { validade, ...rest } = prev;
            return rest;
          });
        }
      }
    } else {
      setErros((prev) => ({
        ...prev,
        validade: tPagamento("cards.invalidDate"),
      }));
    }
  }

  function handleChangeVencimento(e) {
    let novoValor = e.target.value;

    novoValor = novoValor.replace(/\D/g, "");
    novoValor = novoValor.slice(0, 6);

    verificarDataValidade(novoValor);
    setValidade(novoValor);
  }

  function getVencimento() {
    let novaValidade = validade;

    if (novaValidade.length > 2) {
      const parte1 = novaValidade.slice(0, 2);
      const parte2 = novaValidade.slice(2);

      return `${parte1}/${parte2}`;
    } else {
      return novaValidade;
    }
  }

  function handleChangeNumeroCartao(e) {
    let novoNumeroCartao = e.target.value;

    novoNumeroCartao = novoNumeroCartao.replace(/\D/g, "");
    novoNumeroCartao = novoNumeroCartao.slice(0, 16);

    if (!novoNumeroCartao) {
      setErros((prev) => ({
        ...prev,
        numeroCartao: tPagamento("cards.fillNumber"),
      }));
    } else {
      setErros((prev) => {
        const { numeroCartao, ...rest } = prev;
        return rest;
      });
    }

    setNumeroCartao(novoNumeroCartao);
  }

  function handleChangeCPF(e) {
    let novoNumeroCpf = e.target.value;

    novoNumeroCpf = novoNumeroCpf.replace(/\D/g, "");
    novoNumeroCpf = novoNumeroCpf.slice(0, 11);

    verificarCPF(novoNumeroCpf);

    setCpf(novoNumeroCpf);
  }

  function verificarCPF(cpf) {
    const cpfValido = validarCPF(cpf);

    if (!cpfValido) {
      setErros((prev) => ({ ...prev, cpf: tPagamento("cards.invalidCpf") }));
    } else {
      setErros((prev) => {
        const { cpf, ...rest } = prev;
        return rest;
      });
    }
  }

  function handleChangeCodigoSeguranca(e) {
    let novoCodigoSeguranca = e.target.value;

    novoCodigoSeguranca = novoCodigoSeguranca.replace(/\D/g, "");
    novoCodigoSeguranca = novoCodigoSeguranca.slice(0, 3);

    if (!novoCodigoSeguranca) {
      setErros((prev) => ({
        ...prev,
        codigoSeguranca: tPagamento("cards.fillSecurityCode"),
      }));
    } else {
      setErros((prev) => {
        const { codigoSeguranca, ...rest } = prev;
        return rest;
      });
    }

    setCodigoSeguranca(novoCodigoSeguranca);
  }

  function cadastrarCartao(close) {
    let cartao = {
      numeroCartao: numeroCartao,
      nomeDonoCartao: nomeCartao,
      validade: validade,
      codigoSeguranca: codigoSeguranca,
      cpf: cpf,
    };

    const novoCartao = RequestPagamentoCartao.mapCartao(cartao);

    let erro = false;

    Object.keys(erros).forEach((key) => {
      if (cartao[key]) {
        erro = true;
      }
    });

    Object.keys(cartao).forEach((key) => {
      if (!novoCartao[key]) {
        erro = true;
        setErros((prev) => ({ ...prev, [key]: tPagamento("cards.fillField") }));
      }
    });

    if (erro) {
      toast.warn(tPagamento("cards.invalidFields"));
      return;
    }

    post("/pagamento/cartao", novoCartao)
      .then((response) => {
        if (response.status === 200) {
          close();
          onCadastradoComSucesso();
          toast.info(tPagamento("cards.created"));
        } else if (response.data.message) {
          toast.warn(response.data.message);
        } else {
          let json = response.data;
          let erros = {};

          erros = incrementarErro(erros, json, "numeroCartao");
          erros = incrementarErro(erros, json, "codigoSeguranca");
          erros = incrementarErro(erros, json, "cpf");
          erros = incrementarErro(erros, json, "nomeDonoCartao");
          erros = incrementarErro(erros, json, "validade");

          console.error(erros);
          setErros(erros);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(tPagamento("cards.createError"));
      });
  }

  function editarCartao(close) {
    let cartao = {
      nomeDonoCartao: nomeCartao,
      validade: validade,
      cpf: cpf,
    };

    let erro = false;

    Object.keys(erros).forEach((key) => {
      if (cartao[key]) {
        erro = true;
      }
    });

    Object.keys(cartao).forEach((key) => {
      if (!cartao[key]) {
        erro = true;
        setErros((prev) => ({ ...prev, [key]: tPagamento("cards.fillField") }));
      }
    });

    if (erro) {
      toast.warn(tPagamento("cards.invalidFields"));
      return;
    }

    put("/pagamento/cartao/" + dadosEditar.id, cartao)
      .then((response) => {
        if (response.status === 200) {
          close();
          onCadastradoComSucesso();
          toast.info(tPagamento("cards.created"));
        } else if (response.data.message) {
          toast.warn(response.data.message);
        } else {
          let json = response.data;
          let erros = {};

          erros = incrementarErro(erros, json, "numeroCartao");
          erros = incrementarErro(erros, json, "codigoSeguranca");
          erros = incrementarErro(erros, json, "cpf");
          erros = incrementarErro(erros, json, "nomeDonoCartao");
          erros = incrementarErro(erros, json, "validade");

          console.error(erros);
          setErros(erros);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(tPagamento("cards.createError"));
      });
  }

  function incrementarErro(listaErros, json, campo) {
    let mensagem = json[campo];

    if (mensagem) {
      return { ...listaErros, [campo]: mensagem };
    }

    return json;
  }

  function buscarDadosEdicao() {
    if (dadosEditar) {
      setLoading(true);
      get("/pagamento/cartao/" + dadosEditar.id)
        .then((response) => {
          let dadosCartao = response.data;
          setNumeroCartao(`*** *** *** *** ${dadosEditar.numero}`);
          verificarDataValidade(String(dadosCartao.validade).replace("/", ""));
          setValidade(String(dadosCartao.validade).replace("/", ""));
          setNomeCartao(dadosCartao.nomeDonoCartao);
          setCpf(dadosCartao.cpf);
          setCodigoSeguranca("***");
          setLoading(false);
          setDataAlteracao(dadosCartao.dtAlteracao);
          setDataCriacao(dadosCartao.dtCadastro);
        })
        .catch((error) => {
          console.error(error);
          toast.error(tPagamento("cards.loadError"));
          setLoading(false);
        });
    }
  }

  function resetarValoresEdicao() {
    if (dadosEditar) {
      setErros({});
      buscarDadosEdicao();
    }
  }

  useEffect(() => {
    if (!dadosEditar && location.pathname.endsWith("/carteira")) {
      setOpenCartao(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (dadosEditar) {
      buscarDadosEdicao();
    }
  }, [dadosEditar]);

  return (
    <PopupCustomizado
      temDatas={dataCriacao && dataAlteracao}
      trigger={componenteTrigger}
      onOpen={() => {
        setOpenCartao(true);

        if (!window.location.pathname.endsWith("/carteira") && !dadosEditar) {
          window.history.pushState(
            {},
            "",
            `${window.location.pathname}/carteira`,
          );
        }
      }}
      onClose={() => {
        setOpenCartao(false);
        if (dadosEditar) {
          resetarValoresEdicao();
        } else {
          window.history.replaceState(
            {},
            "",
            window.location.pathname.replace("/carteira", ""),
          );
        }
      }}
      open={openCartao}
      modal
      nested
    >
      {(close) =>
        loading ? (
          <div
            style={{
              display: "flex",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Carregando adaptavel />
          </div>
        ) : (
          <ContainerPopup>
            <CabecalhoModal>
              <TextoCabecalhoModalNovoCartao>
                {dadosEditar
                  ? tPagamento("cards.edit")
                  : tPagamento("cards.new")}
              </TextoCabecalhoModalNovoCartao>
              <SubTextoCabecalhoModalNovoCartao>
                {empresaDTO?.apelido}
              </SubTextoCabecalhoModalNovoCartao>
            </CabecalhoModal>
            <LinhaCabecalho />
            <ContainerBodyModal>
              <ContainerInputsModal>
                <CampoDeTexto
                  titulo={tPagamento("cards.number")}
                  InputProps={{ type: "text" }}
                  variant="standard"
                  value={numeroCartao}
                  onChange={handleChangeNumeroCartao}
                  required
                  error={erros.numeroCartao}
                  helperText={erros?.numeroCartao}
                  disabled={dadosEditar ? true : false}
                />
                <CampoDeTexto
                  titulo={tPagamento("cards.cpf")}
                  variant="standard"
                  InputProps={{ type: "text" }}
                  onChange={handleChangeCPF}
                  value={formatarCPF(cpf)}
                  required
                  error={erros.cpf}
                  helperText={erros?.cpf}
                />
                <CampoDeTexto
                  titulo={tPagamento("cards.holderName")}
                  variant="standard"
                  InputProps={{ type: "text" }}
                  onChange={handleChangeNomeCartao}
                  value={nomeCartao}
                  required
                  error={erros.nomeDonoCartao}
                  helperText={erros?.nomeDonoCartao}
                />

                <InputsVencimentoCvv>
                  <CampoDeTexto
                    titulo={tPagamento("cards.expiration")}
                    style={{ width: "50%" }}
                    variant="standard"
                    placeholder={tPagamento("cards.expirationPlaceholder")}
                    onChange={handleChangeVencimento}
                    value={getVencimento()}
                    required
                    error={erros.validade}
                    helperText={erros?.validade}
                  />

                  <CampoDeTexto
                    titulo={tPagamento("cards.securityCode")}
                    style={{ width: "50%" }}
                    variant="standard"
                    value={codigoSeguranca}
                    onChange={handleChangeCodigoSeguranca}
                    required
                    error={erros.codigoSeguranca}
                    helperText={erros?.codigoSeguranca}
                    disabled={dadosEditar ? true : false}
                  />
                </InputsVencimentoCvv>

                { dataCriacao && dataAlteracao &&
                  <InputsDatasCartao>
                    <CampoDeTexto
                        titulo="Data de Criação"
                        style={{ width: "50%" }}
                        variant="standard"
                        value={formatarDataEHorarioParaPadraoBrasileiro(dataCriacao)}
                        disabled={true}
                    />
                    <CampoDeTexto
                        titulo="Data de Alteração"
                        style={{ width: "50%" }}
                        variant="standard"
                        value={formatarDataEHorarioParaPadraoBrasileiro(dataAlteracao)}
                        disabled={true}
                    />
                  </InputsDatasCartao>
                }

              </ContainerInputsModal>
              <ContainerCartaoModal>
                <CartaoModal>
                  <NomeCartaoModal>{nomeCartao}</NomeCartaoModal>
                  <NumeroCartaoModal>{numeroCartao}</NumeroCartaoModal>
                </CartaoModal>
                <BotoesModal>
                  <BotaoCancelar onClick={close}>
                    <TextoBotaoCancelar
                      onClick={() => {
                        setOpenCartao(false);
                        close();
                      }}
                    >
                      {t("buttons.cancel")}
                    </TextoBotaoCancelar>
                  </BotaoCancelar>
                  {dadosEditar ? (
                    <BotaoCadastrarCartaoModal
                      onClick={() => editarCartao(close)}
                    >
                      <TextoBotaoCadastrarCartaoModal>
                        {tPagamento("cards.edit")}
                      </TextoBotaoCadastrarCartaoModal>
                    </BotaoCadastrarCartaoModal>
                  ) : (
                    <BotaoCadastrarCartaoModal
                      onClick={() => cadastrarCartao(close)}
                    >
                      <TextoBotaoCadastrarCartaoModal>
                        {tPagamento("cards.register")}
                      </TextoBotaoCadastrarCartaoModal>
                    </BotaoCadastrarCartaoModal>
                  )}
                </BotoesModal>
              </ContainerCartaoModal>
            </ContainerBodyModal>
          </ContainerPopup>
        )
      }
    </PopupCustomizado>
  );
}
